<template>
  <div class="home">
    I am the app
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',


}
</script>
